module.exports = __webpack_public_path__ + "static/media/Kids.5e71bfea.svg";